module.exports = __webpack_public_path__ + "img/Best of Tessin weiss.5b1c5756.jpg";